import { Component, HostListener, OnInit, Input } from '@angular/core';
import { TenantFolderDto } from 'app/api/models/tenant/tenantFolderDto';
import { TenantTeamDto } from 'app/api/models/tenant/tenantTeamDto';
import { TenantsService } from 'app/state/tenants.service';
import { Table } from 'primeng/table';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-tenant-teams',
  templateUrl: './tenant-teams.component.html',
  styleUrl: './tenant-teams.component.scss',
  standalone: false,
})
export class TenantTeamsComponent implements OnInit {
  constructor(private tenantService: TenantsService) {}

  @Input({ required: true }) tenantId!: string;

  deleteConfirmation: TenantTeamDto | null = null;

  teams: TenantTeamDto[] = [];
  newTeamText: string = '';
  innerWidth = 0;
  bgColors = [
    'oklch(0.85 0.1 30)',
    'oklch(0.85 0.1 145)',
    'oklch(0.85 0.1 250)',
    'oklch(0.85 0.1 350)',
  ];
  ngOnInit(): void {
    this.refreshData();
    this.innerWidth = window.innerWidth;
  }

  getColor(index: number): string {
    return this.bgColors[index % this.bgColors.length];
  }
  @HostListener('window:resize')
  onResize() {
    this.innerWidth = window.innerWidth;
  }

  addTeam() {
    if (this.newTeamText.trim()) {
      let newTeam = new TenantTeamDto();
      newTeam.name = this.newTeamText;
      this.tenantService
        .addTenantTeam(this.tenantId, newTeam)
        .pipe(untilDestroyed(this))
        .subscribe((x) => {
          this.refreshData();
          this.newTeamText = '';
        });
    }
  }

  refreshData() {
      this.tenantService.getAllTenantsTeams(this.tenantId)
          .pipe(untilDestroyed(this))
          .subscribe((x) => {
      this.teams = x;
    });
  }

  handleDeleteClick(team: TenantTeamDto) {
    this.tenantService
        .deleteTenantTeam(this.tenantId, team.id!)
        .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.refreshData();
      });
  }

  onGlobalFilter(table: Table, event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    table.filterGlobal(inputElement.value, 'contains');
  }
}
